/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Audit_Details_Self_Approval_Prohibited_DescInputs */



/**
* | output |
* | --- |
* | "Members were no longer allowed to auto-approve the {integration} integration's write tools for the organisation." |
*
* @param {Audit_Details_Self_Approval_Prohibited_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_self_approval_prohibited_desc = /** @type {((inputs: Audit_Details_Self_Approval_Prohibited_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Self_Approval_Prohibited_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mitglieder dürfen die Schreib-Werkzeuge der Integration ${i?.integration} nicht mehr selbst automatisch freigeben.`)
	return /** @type {LocalizedString} */ (`Members were no longer allowed to auto-approve the ${i?.integration} integration's write tools for the organisation.`)
});